import { render, staticRenderFns } from "./CompanyPptPage.vue?vue&type=template&id=c63b3708&scoped=true"
import script from "./CompanyPptPage.vue?vue&type=script&lang=js"
export * from "./CompanyPptPage.vue?vue&type=script&lang=js"
import style0 from "./CompanyPptPage.vue?vue&type=style&index=0&id=c63b3708&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63b3708",
  null
  
)

export default component.exports